import CityPageTemplate from "../city-template/CityPageTemplate";
import { somersworthConfig } from "./data";

export default function SomersworthPage() {
  return <CityPageTemplate config={somersworthConfig} />;
}